var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCertified = function SvgCertified(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#certified_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 19.292c-.267 0-.533-.1-.733-.309l-2.109-2.108H4.175a1.042 1.042 0 0 1-1.042-1.042V12.85l-2.108-2.108a1.041 1.041 0 0 1 0-1.475l2.108-2.109V4.175c0-.575.467-1.042 1.042-1.042h2.983l2.109-2.108a1.041 1.041 0 0 1 1.475 0l2.108 2.108h2.983c.575 0 1.042.467 1.042 1.042v2.983l2.108 2.109a1.041 1.041 0 0 1 0 1.475l-2.108 2.108v2.983c0 .575-.467 1.042-1.042 1.042H12.85l-2.108 2.108c-.2.2-.467.309-.734.309H10Zm-5.625-3.667h3.033c.167 0 .325.067.442.183l2.15 2.15 2.15-2.15a.625.625 0 0 1 .442-.183h3.033v-3.033c0-.167.067-.325.183-.442l2.15-2.15-2.15-2.15a.625.625 0 0 1-.183-.442V4.375h-3.033a.624.624 0 0 1-.442-.183L10 2.042l-2.15 2.15a.624.624 0 0 1-.442.183H4.375v3.033a.624.624 0 0 1-.183.442L2.042 10l2.15 2.15a.624.624 0 0 1 .183.442v3.033Zm5.283-3.333 3.7-3.7a.629.629 0 0 0 0-.884.629.629 0 0 0-.883 0l-3.258 3.259-1.692-1.692a.629.629 0 0 0-.883 0 .629.629 0 0 0 0 .883l2.133 2.134a.625.625 0 0 0 .883 0Z",
    fill: "current"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "certified_svg__a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: "100%",
    fill: "#fff"
  })))));
};
export default SvgCertified;